"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseCoordinate = parseCoordinate;
exports.coordsToString = coordsToString;
function parseCoordinate(coordinate) {
    if (!coordinate)
        return {};
    const [name, version] = coordinate.split('@');
    const [groupId, artifactId, type, classifier] = (name !== null && name !== void 0 ? name : '').split(':');
    return {
        groupId: groupId || undefined,
        artifactId: artifactId || undefined,
        version: version || undefined,
        type: type || undefined,
        classifier: classifier || undefined,
    };
}
function coordsToString(coords) {
    let name = `${coords.groupId || 'unknown'}:${coords.artifactId || 'unknown'}:${coords.type || 'jar'}`;
    if (coords.classifier)
        name += `:${coords.classifier}`;
    return `${name}@${coords.version || 'unknown'}`;
}
//# sourceMappingURL=coordinate.js.map